//We need to choose a standard between these formats. Both are riddled throughout the codebase.
export type MSLatLon = { lat: number; lon: number };
export type MSLatLng = { lat: number; lng: number };

export type MSLatLonPlace = MSLatLon & { name: string };
export type MSLatLngPlace = MSLatLng & { name: string | null };

export type MSLatLngBounds = {
  center: MSLatLng;
  southwest: MSLatLng;
  northeast: MSLatLng;
};

export interface MSPoint {
  x: number;
  y: number;
}

export interface MSPointBounds {
  southwest: MSPoint;
  center: MSPoint;
  northeast: MSPoint;
}

export type MSCameraConfig = {
  center: MSLatLng;
  zoom: number;
};

export enum MSMapType {
  NORMAL = 'Normal',
  HYBRID = 'Hybrid',
  SATELLITE = 'Satellite',
  TERRAIN = 'Terrain',
  NONE = 'None'
}
